module.exports = __webpack_public_path__ + "static/services-1c730f56876127bd9fb39c4d65d75d09.jpg";